import { Squash as Hamburger } from 'hamburger-react';
import { PropTypes } from 'prop-types';
import React, { useEffect, useState } from 'react';

import { BREAKPOINTS } from '../../constants/breakpoints';

const HamburgerMenu = ({ color, minified, onClick, open, scrollDown }) => {
  const [mobile, setMobile] = useState(false);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onClick();
    }
  };

  const handleResize = () => {
    if (window.innerWidth <= BREAKPOINTS.mobileXL) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  };
  useEffect(() => {
    window.addEventListener('resize', () => handleResize(window));
    handleResize();
    return () =>
      window.removeEventListener('resize', () => handleResize(window));
  }, []);

  return (
    <div
      aria-controls="extendedMenu"
      aria-expanded={open}
      aria-label="More options"
      className={`nav__hamburger ${minified ? 'minified' : ''} ${
        scrollDown ? 'scrolling__down' : ''
      }`}
      data-component-id="hamburger_menu"
      onClick={onClick}
      onKeyPress={handleKeyPress}
    >
      <Hamburger
        color={color}
        hideOutline={false}
        size={mobile ? 20 : 27}
        toggled={open}
      />
    </div>
  );
};

HamburgerMenu.propTypes = {
  color: PropTypes.string,
  minified: PropTypes.bool,
  onClick: PropTypes.func,
  open: PropTypes.bool,
  scrollDown: PropTypes.bool,
};

export default HamburgerMenu;
